export default "__VITE_ASSET__CU6K9Jvp__"